/**
 * Simple video loader logic
 * - Lazy load videos
 * - data-load='lazy' attribute on video elements
 * - replace src with data-src in order for it to work
 */
export default (function lazyVideoLoader() {
  const lazyVideos = [...document.querySelectorAll("[data-load='lazy']")];

  function enableVideo(video) {
    const videoSrc = video.dataset.src;
    if (videoSrc) {
      video.setAttribute('src', videoSrc);
    }

    [...video.children].forEach((child) => {
      if (child.tagName === 'SOURCE' && child.dataset.src) {
        child.setAttribute('src', child.dataset.src);
      }
    });

    if (video.readyState === 0) {
      video.load();
    }

    video.setAttribute('data-load', 'loaded');
  }

  if ('IntersectionObserver' in window) {
    // Create an IntersectionObserver to observe lazy-loaded videos
    const lazyVideoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          enableVideo(entry.target);
          observer.unobserve(entry.target); // Unobserve the video element once loaded
        }
      });
    });

    // Observe each lazy video
    lazyVideos.forEach((lazyVideo) => lazyVideoObserver.observe(lazyVideo));
  } else {
    // Fallback for browsers that do not support IntersectionObserver
    lazyVideos.forEach((video) => enableVideo(video));
  }

  // Listen to Video Modal open event to enable video when modal is opened
  document.addEventListener('videoModalOpened', (event) => {
    const videoElement = event.detail.video;
    enableVideo(videoElement);
  });
})();
